'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _shallowEqual = require('fbjs/lib/shallowEqual');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _getTheme = require('./getTheme');

var _getTheme2 = _interopRequireDefault(_getTheme);

var _breakpoints = require('./breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _withSpacing = require('./withSpacing');

var _withSpacing2 = _interopRequireDefault(_withSpacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alignMap = {
  start: 'flex-start',
  end: 'flex-end'
};

var isNil = function isNil(val) {
  return val === undefined || val === null;
};

var Col = (0, _glamorous2.default)('div', {
  shouldClassNameUpdate: function shouldClassNameUpdate(props, nextProps, context, nextContext) {
    return !(0, _shallowEqual2.default)(context.theme, nextContext.theme) || !(0, _shallowEqual2.default)(props.span, nextProps.span) || !(0, _shallowEqual2.default)(props.equalWidth, nextProps.equalWidth) || !(0, _shallowEqual2.default)(props.auto, nextProps.auto) || !(0, _shallowEqual2.default)(props.offset, nextProps.offset) || !(0, _shallowEqual2.default)(props.alignSelf, nextProps.alignSelf) || !(0, _shallowEqual2.default)(props.textAlign, nextProps.textAlign);
  }
})({
  position: 'relative',
  width: '100%',
  minHeight: 1,
  boxSizing: 'border-box'
}, function (props) {
  var gridTheme = (0, _getTheme2.default)(props);
  var gutters = gridTheme.column_gutter;

  return (0, _breakpoints2.default)(gutters, gridTheme, function (size) {
    return !isNil(size) && {
      paddingLeft: parseFloat(size) / 2,
      paddingRight: parseFloat(size) / 2
    };
  });
}, function (props) {
  var gridTheme = (0, _getTheme2.default)(props);

  return (0, _breakpoints2.default)(props.span, gridTheme, function (span) {
    return span && {
      flex: '0 0 ' + span * 100 + '%',
      maxWidth: span * 100 + '%'
    };
  });
}, function (props) {
  var gridTheme = (0, _getTheme2.default)(props);

  return (0, _breakpoints2.default)(props.equalWidth, gridTheme, function () {
    var equalWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (equalWidth || !props.equalWidth && !props.span) {
      return {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
    }
  });
}, function (props) {
  var gridTheme = (0, _getTheme2.default)(props);

  return (0, _breakpoints2.default)(props.auto, gridTheme, function () {
    var auto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return auto && {
      flex: '0 0 auto',
      width: 'auto'
    };
  });
}, function (props) {
  var gridTheme = (0, _getTheme2.default)(props);

  return (0, _breakpoints2.default)(props.offset, gridTheme, function (offset) {
    return !isNil(offset) && {
      marginLeft: offset * 100 + '%'
    };
  });
}, function (props) {
  var gridTheme = (0, _getTheme2.default)(props);

  return (0, _breakpoints2.default)(props.alignSelf, gridTheme, function (align) {
    return align && {
      alignSelf: '' + (alignMap[align] || align)
    };
  });
}, function (props) {
  var gridTheme = (0, _getTheme2.default)(props);

  return (0, _breakpoints2.default)(props.textAlign, gridTheme, function (align) {
    return align && {
      textAlign: align
    };
  });
});

exports.default = (0, _withSpacing2.default)(Col);


//////////////////
// WEBPACK FOOTER
// ./~/glamorous-grid/lib/Col.js
// module id = ./node_modules/glamorous-grid/lib/Col.js
// module chunks = 2345137460201621000 7489246917808536000 9249036036638527000